import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _type_of } from "@swc/helpers/_/_type_of";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : _type_of(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { assignSettinThrottleQuickAdds, getSettingThrottledQuickAdds } from "@faire/retailer-visitor-shared/settings/getSettingEnableThrottledQuickAdds";
import { ICartItemForUpdate } from "@faire/retailer-visitor-shared/stores/domain/CartStore/consts";
import { debounceIfPossible } from "@faire/web--source/common/globals/debounceIfPossible";
import { trackEvent } from "@faire/web--source/common/trackEvent";
import { action, observable } from "mobx";
export var BULK_UPDATE_DEBOUNCE_THREHOLD = 3000;
var OPTIMIZED_BULK_UPDATE_DEBOUNCE_THREHOLD = 500;
/**
 * @deprecated use `useBulkUpdateCartItem` instead in functional components
 */ export var BulkUpdateItemClass = function BulkUpdateItemClass(updateCart, container) {
    "use strict";
    var _this = this;
    _class_call_check(this, BulkUpdateItemClass);
    var _this1 = this;
    this.updateCart = updateCart;
    this.container = "";
    this.bulkUpdates = {};
    this.itemType = {};
    this.track = function(token, isMultiOption) {
        var _$container = _this.container;
        var cartAddType = isMultiOption ? "quick_add_with_options_chosen" : "quick_add";
        trackEvent("/container/".concat(_$container, "/").concat(cartAddType, "/").concat(token));
    };
    this.bulkUpdateItems = function(productToken, productOptionToken, value, isMultiOption, brandToken, variant, onSubmit) {
        var key = productToken + productOptionToken;
        var currentTime = performance.now();
        _this.bulkUpdates[key] = ICartItemForUpdate.build({
            product_token: productToken,
            product_option_token: productOptionToken,
            quantity: value < 0 ? 0 : value,
            brand_token: brandToken
        });
        _this.itemType[key] = isMultiOption;
        if (Object.values(_this.bulkUpdates).length) {
            _this.debouncedUpdateCart(variant, currentTime, onSubmit);
        }
    };
    this.debouncedUpdateCart = debounceIfPossible(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(variant, timeOfLastAddToCartClick, onSubmit) {
            var updatedCartItems;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!_this1.updateCart) return [
                            3,
                            2
                        ];
                        assignSettinThrottleQuickAdds();
                        Object.values(_this1.bulkUpdates).forEach(function(value) {
                            var _value_product_token, _value_product_option_token;
                            var key = ((_value_product_token = value.product_token) !== null && _value_product_token !== void 0 ? _value_product_token : "") + ((_value_product_option_token = value.product_option_token) !== null && _value_product_option_token !== void 0 ? _value_product_option_token : "");
                            var _value_product_option_token1;
                            _this1.track((_value_product_option_token1 = value.product_option_token) !== null && _value_product_option_token1 !== void 0 ? _value_product_option_token1 : "", _this1.itemType[key] || false);
                        });
                        updatedCartItems = Object.values(_this1.bulkUpdates);
                        _this1.bulkUpdates = {};
                        return [
                            4,
                            _this1.updateCart(updatedCartItems, {
                                upltParams: {
                                    event: "add-to-cart",
                                    startTime: timeOfLastAddToCartClick,
                                    variant: variant
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function(variant, timeOfLastAddToCartClick, onSubmit) {
            return _ref.apply(this, arguments);
        };
    }(), OPTIMIZED_BULK_UPDATE_DEBOUNCE_THREHOLD, {
        leading: getSettingThrottledQuickAdds()
    });
    this.container = container;
};
__decorate([
    observable
], BulkUpdateItemClass.prototype, "bulkUpdates", void 0);
__decorate([
    observable
], BulkUpdateItemClass.prototype, "itemType", void 0);
__decorate([
    action
], BulkUpdateItemClass.prototype, "bulkUpdateItems", void 0);
